import Base from './base';
import Full from './full';
import Preview from './preview';
import Proximity from './proximity';
import ProximityFull from './proximity-full';
import ProximityPreview from './proximity-preview';
import Temperature from './temperature';
import TemperatureFull from './temperature-full';
import TemperaturePreview from './temperature-preview';
import Touch from './touch';
import TouchFull from './touch-full';
import TouchPreview from './touch-preview';

export default {
    Base,
    Full,
    Preview,
    Proximity,
    ProximityFull,
    ProximityPreview,
    Temperature,
    TemperatureFull,
    TemperaturePreview,
    Touch,
    TouchFull,
    TouchPreview
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/index.js